import { Globe } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { useLocale, type Locale } from '@/i18n/index'

const LOCALES: { code: Locale; label: string; flag: string }[] = [
	{ code: 'en', label: 'English', flag: '🇺🇸' },
	{ code: 'ar', label: 'العربية', flag: '🇸🇦' },
	{ code: 'fr', label: 'Français', flag: '🇫🇷' },
]

export default function LanguageSwitcher() {
	const { locale, setLocale } = useLocale()
	const [open, setOpen] = useState(false)
	const ref = useRef<HTMLDivElement>(null)

	useEffect(() => {
		const handler = (e: MouseEvent) => {
			if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
		}
		document.addEventListener('mousedown', handler)
		return () => document.removeEventListener('mousedown', handler)
	}, [])

	return (
		<div ref={ref} className='relative flex items-center'>
			<button
				onClick={() => setOpen(o => !o)}
				className='p-1 flex items-center justify-center'
				aria-label='Change language'
			>
				<Globe className='w-5 h-5 text-[#929093]' />
			</button>
			{open && (
				<div className='absolute end-0 top-8 z-50 bg-[#222225] rounded-xl border border-zinc-700 py-1 min-w-[140px] shadow-lg'>
					{LOCALES.map(l => (
						<button
							key={l.code}
							onClick={() => { setLocale(l.code); setOpen(false) }}
							className={`w-full px-3 py-2 text-start text-sm flex items-center gap-2 hover:bg-zinc-700 transition-colors ${
								locale === l.code ? 'text-white font-semibold' : 'text-[#929093]'
							}`}
						>
							<span>{l.flag}</span>
							<span>{l.label}</span>
						</button>
					))}
				</div>
			)}
		</div>
	)
}
